import { render, staticRenderFns } from "./TraveldocEdit.vue?vue&type=template&id=dceddd66&"
import script from "./TraveldocEdit.vue?vue&type=script&lang=js&"
export * from "./TraveldocEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports